export default __webpack_public_path__ + "static/media/txt_white.7800d001.png";